// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomerWithBookingsResponse

import { hydrateBookingSummary, type BookingSummary, type BookingSummaryApiResponse } from './bookingSummary.gen';

export type CustomerWithBookingsApiResponse = {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	phone: string;
	phoneOptIn: boolean;
	emailOptIn: boolean;
	isVip: boolean;
	totalSpent: number;
	firstBookingId: string | null;
	lastBookingId: string | null;
	totalBookings: number;
	preferredLocale: string;
	tags: Array<string>;
	customFields: Record<string, string>;
	bookings: BookingSummaryApiResponse[];
};

export type CustomerWithBookings = {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	phone: string;
	phoneOptIn: boolean;
	emailOptIn: boolean;
	isVip: boolean;
	totalSpent: number;
	firstBookingId: string | null;
	lastBookingId: string | null;
	totalBookings: number;
	preferredLocale: string;
	tags: Array<string>;
	customFields: Record<string, string>;
	bookings: BookingSummary[];
};

export function hydrateCustomerWithBookings(data: CustomerWithBookingsApiResponse): CustomerWithBookings {
	return {
		...data,
		customFields: Array.isArray(data.customFields) ? {} : data.customFields,
		bookings: data.bookings.map(hydrateBookingSummary),
	};
}